import Identity from '../../repo/identity';
import observe from '../../util/observe';
import template from './protected-content.tpl';

const ProtectedContent = DomClass(template, function withAuthentication() {
	const _t = this;

	this.refresh = () => {
		if (Identity.user) {
			if (typeof(this.content) == 'function') {
				this.visibleContent = this.content();
			} else {
				this.visibleContent = this.content;
			}
		} else {
			this.visibleContent = this.error || "Woops! You need to sign in first.";
		}
	};

	this.refresh();

	observe(Identity, 'user', () => _t.refresh());
});

export default ProtectedContent;